export const CAMPAIGN_CONTENT_FIELDS = [
  'name', 'description', 'rules_allowed', 'rules_forbidden', 'rules_attention',
  'rules_warning', 'required_hashtags', 'required_mention', 'banner_url', 'logo_url',
] as const;
export type CampaignContentField = typeof CAMPAIGN_CONTENT_FIELDS[number];
export type CampaignContentDraft = Partial<Record<CampaignContentField, string>>;
export type CampaignContentSnapshot = Partial<Record<CampaignContentField, string | null>> & {
  content_locked: boolean;
  editing_locked_reason?: string | null;
};

export const PERIOD_CONTENT_FIELDS: readonly CampaignContentField[] = [
  'description', 'rules_allowed', 'rules_forbidden', 'rules_attention',
  'rules_warning', 'required_hashtags', 'required_mention',
];

export function buildCampaignContentInput(
  original: CampaignContentSnapshot,
  draft: Record<string, unknown>,
): CampaignContentDraft {
  const input: CampaignContentDraft = {};
  for (const field of CAMPAIGN_CONTENT_FIELDS) {
    if (!Object.prototype.hasOwnProperty.call(draft, field)) continue;
    const value = draft[field];
    if (typeof value !== 'string') throw new Error('campaign_content_invalid');
    if (value === (original[field] ?? '')) continue;
    if (field === 'name' && (!value.trim() || value.length > 255)) throw new Error('campaign_content_invalid');
    if ((field === 'banner_url' || field === 'logo_url') && value.trim()) {
      let url: URL;
      try { url = new URL(value.trim()); } catch { throw new Error('campaign_content_invalid'); }
      if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password || value.length > 2048) throw new Error('campaign_content_invalid');
    }
    if (value.length > 65_536) throw new Error('campaign_content_invalid');
    input[field] = value;
  }
  if (!Object.keys(input).length) return input;
  if (original.editing_locked_reason === 'ranking_finalized') throw new Error('ranking_finalized');
  if (original.content_locked && original.editing_locked_reason !== 'ranking_period_locked') throw new Error('campaign_content_locked');
  if (original.content_locked && Object.keys(input).some(field => PERIOD_CONTENT_FIELDS.includes(field as CampaignContentField))) {
    throw new Error(original.editing_locked_reason || 'ranking_period_locked');
  }
  return input;
}
